/**
 * Created by Bart Decorte
 * Date: 09/11/2018
 * Time: 14:18
 */
import 'select2';
import { api } from '../../../utils/api';

class UserSelect {
  constructor(element, params = {}) {
    this.params = {
      $elt: element instanceof jQuery ? element : $(element),
    };

    this.select2();
  }

  get element() {
    return this.params.$elt.next().get(0);
  }

  select2() {
    const select = this.params.$elt.get(0);
    this.params.$elt.select2({
      containerCssClass: select.getAttribute('class'),
      dropdownAutoWidth: true,
      dropdownCssClass:
        'dropdown-menu dropdown-menu-right dropdown-menu-sm show',
      ajax: {
        url: api.users.search,
        dataType: 'json',
        data: UserSelect.data,
        processResults: UserSelect.processResults,
      },
    });
  }

  static data(params) {
    return { term: params.term };
  }

  static processResults(response) {
    return {
      results: response.data.map((x) => {
        return { id: x.id, text: x.email };
      }),
    };
  }
}

if (typeof $ !== typeof undefined) {
  $.fn.extend({
    userSelect: function(params = {}) {
      return new UserSelect($(this), params);
    },
  });
}

export default UserSelect;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Users/_partials/UserSelect.js